module.exports = __webpack_public_path__ + "static/feature-01-3b23b6642c7b51c904c622f46913c0c0.jpg";